import {i18nModule} from "@config/i18n.module";
import {ResourcesModule} from "@resources/resources.module";
import {UtilsModule} from "@utils/utils.module";
import {NgModule} from "@angular/core";
import {DynamicComponentModule} from "ng-dynamic";

var modulesImport: Array<any> = [
  /** Liste des modules */
  UtilsModule,
  ResourcesModule,
  i18nModule,
  DynamicComponentModule.forRoot({
    imports: [UtilsModule, i18nModule]
  })
];

var modulesExport: Array<any> = [
  /** Liste des modules */
  UtilsModule,
  ResourcesModule,
  i18nModule,
  DynamicComponentModule,
];


@NgModule({
  imports: modulesImport,
  exports: modulesExport,
  providers: [
  ]
})
export class CerbaCommonModule {


}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-paiement-factures/digicerba-paiement-factures-web/src/angular/cerba/src/app/common/cerba-common.module.ts